const messages = {
  titleProduct: '¿Qué vas a pagar?',
}

export default messages
